// import { getDateFrom } from '../functions/format_date'
import Moment from 'moment'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      isShowFilter: false,
      isDataPageLoading: true,
      createModal: {
        show: false,
        title: `Create ${this.modalTitle}`
      },
      editModal: {
        show: false,
        title: `Edit ${this.modalTitle}`,
        submitButtonText: 'Edit',
        form: null
      },
      dateFilters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          value: Moment().startOf('month').toISOString()
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          value: Moment().endOf('month').toISOString()
        }
      },
      tableRowModal: {
        fields: [
          {
            key: 'own_bank_details.summary',
            label: 'Own bank details'
          },
          {
            key: 'project.name',
            label: 'Project name'
          },
          {
            key: 'client_bank_details.summary',
            label: 'Client bank details'
          },
          {
            key: 'invoice_status.display_name',
            label: 'Invoice status'
          },
          {
            key: 'invoice_template_type.name',
            label: 'Invoice template type'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'comment_national',
            label: 'Comment national'
          },
          {
            key: 'issue_date',
            label: 'Issue date'
          },
          {
            key: 'due_date',
            label: 'Due date'
          },
          {
            key: 'invoice_type.type',
            label: 'Invoice type'
          },
          {
            key: 'client_bank_details',
            type: 'slot',
            label: 'Client name',
            slotName: 'client_name'
          },
          {
            key: 'total_amount',
            label: 'Total amount'
          },
          {
            key: 'periods',
            type: 'slot',
            label: 'Periods',
            slotName: 'periods'
          },
          {
            key: 'items',
            type: 'slot',
            label: 'Items',
            slotName: 'items'
          },
          {
            key: 'specialisations',
            type: 'slot',
            label: 'Specialisations',
            slotName: 'specialisations'
          }
        ]
      }
    }
  },
  created () {
    this.isShowFilter = false
    this.getCreateEditModal()
    this.fetchAllData()
      .then(() => {
        this.isDataPageLoading = false
        this.setFilters(this.filters)
      })
      .finally(() => {
        this.isShowFilter = true
      })
  },
  computed: {
    ...mapGetters({
      getInvoices: 'finances/getInvoices',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getStatuses: 'finances/getStatuses',
      getProjects: 'projects/getProjects',
      getTemplates: 'finances/getTemplates',
      getClientsBankDetailsAll: 'finances/getClientsBankDetailsAll',
      getInvoicesTypes: 'finances/getInvoicesTypes',
      getIsModalLoading: 'finances/getIsModalLoading',
      getAllUsers: 'getAllUsers',
      getPartners: 'partners/getPartners'
    }),
    getActualProjects () {
      return this.getProjects
        .filter(project => project.project_status.name !== 'done')
    }
  },
  methods: {
    getCreateEditModal () {
      this.createModal.form = cloneDeep(this.formMock)
      this.createModal.title = `Create ${this.modalTitle}`
      this.editModal.form = cloneDeep(this.formMock)
      this.editModal.title = `Edit ${this.modalTitle}`
    },
    showCreateModal () {
      this.createModal.show = true
      this.createModal.form = null
    },
    hideCreateModal () {
      this.createModal.show = false
    },
    showEditModal (params) {
      this.editModal.show = true
      this.editModal.form = params
    },
    hideEditModal () {
      this.editModal.show = false
      this.editModal.form = null
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    fetchAllData () {
      return Promise.all([
        this.fetchAllBankDetails(),
        this.fetchProjects(),
        this.fetchAllUsers()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    async setFilters (data) {
      await this.setParamsFilters(data)
      await this.setParamsCurrentPage()
    },
    async fetchProjects () {
      return this.$api.projects.getProjects()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async fetchAllBankDetails () {
      return this.$api.finances.getBankDetailsAll()
    },
    setAllOptionsFilter () {
      this.filters.bank_details.options = this.getOwnBankDetails
      this.filters.client_details.options = this.getClientsBankDetailsAll
      this.filters.invoice_status.options = this.getStatuses
      this.filters.project.options = this.getProjects
      this.filters.invoice_type.options = this.getInvoicesTypes
    },
    setParamsFilters (data) {
      const that = this
      const filters = Object.values(data).reduce(function (state, current) {
        let value
        if (current['value']) {
          if (current['type'] === 'datepicker') {
            value = that._toLocalTime(current['value'])
          } else if (Array.isArray(current['value'])) {
            if (current['value'].length) {
              value = JSON.stringify(current['value'].map(item => {
                return item.id
              }))
            } else {
              value = null
            }
          } else {
            value = typeof current['value'] === 'object'
              ? current['value'][current['valueField']] : current['value']
          }

          if (value) {
            state += `&filter[${current.name}]=${value}`
          }
        }
        return state
      }, '')
      this.table.params.filters = filters || null
    },
    setParamsSort (sortDesc, sortBy) {
      if (sortBy) {
        const sortDirection = sortDesc ? 'desc' : 'asc'
        this.table.params.sorting = `&sort[${sortBy}]=${sortDirection}`
      }
    },
    setParamsCurrentPage (currentPage = 1) {
      this.table.params.currentPage = currentPage
    }
  }
}
